module.exports = __webpack_public_path__ + "static/media/simon_says_call.1980f5e0.mp3";